// Four states of the Note composer
export const COMPOSER_ERROR = 'COMPOSER_ERROR';
export const COMPOSER_HIDDEN = 'COMPOSER_HIDDEN';
export const COMPOSER_INVISIBLE = 'COMPOSER_INVISIBLE';
export const COMPOSER_LOADING = 'COMPOSER_LOADING';
export const COMPOSER_NO_RECIPIENTS = 'COMPOSER_NO_RECIPIENTS';
export const COMPOSER_VISIBLE = 'COMPOSER_VISIBLE';

// Maximum number of recipients that you can simultaneously send notes to
export const MAX_RECIPIENTS = 15;

// react-scroll identifier for the Note creator block
export const SCROLLABLE_COMPOSER_NAME = 'note-composer';



// WEBPACK FOOTER //
// ./compositions/NotesWidget/constants.js